import { Box, Grid, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { SimpleValueDateRangeType } from "../../../../app/models/requestModels/ClientInvoiceEditRequest";
import { formatDate } from "../../../../components/common/utils/DateUtils";
import { RootState } from "../../../../app/features/store/store";
import { useSelector } from "react-redux";

interface Props {
  date_range_values: SimpleValueDateRangeType[];
  fieldName: string;
  setFieldValue: any;
  isMultiStoreSelected: boolean;
}

export const FieldValueEditList = ({
  date_range_values,
  fieldName,
  setFieldValue,
  isMultiStoreSelected,
}: Props) => {
  const { isLoading, storesForCurrentClientInvoice } = useSelector(
    (state: RootState) => state.clientInvoice
  );

  const getStoreNamesFromStoreIds = (ids: number[]) => {
    let result = "";
    ids.forEach((id, index) => {
      const storeName = storesForCurrentClientInvoice.find(
        (store) => store.id === id
      )?.storeId;
      result += storeName;
      if (index < ids.length - 1) result += ",";
    });
    return result;
  };

  return (
    <Grid container item xs={12} sm={12} md={12} lg={12}>
      <Grid item xs={6}>
        <Box />
      </Grid>
      <Grid item xs={6}>
        {date_range_values.map((item, index) => {
          return (
            <Box>
              <Typography variant="overline">
                <>
                  {isMultiStoreSelected
                    ? `Store: ${getStoreNamesFromStoreIds(
                        item?.storeIds ? item?.storeIds : []
                      )},`
                    : null}
                  Value: {item.fieldValue}{" "}
                  {item.fieldType ? `, Type: ${item.fieldType}` : ""} , Date
                  Range: {formatDate(item.startDate)} to{" "}
                  {formatDate(item.endDate)}
                </>
              </Typography>
              <IconButton
                color="error"
                size="small"
                onClick={() => {
                  const dateRangeValues = date_range_values.filter(
                    (item, idx) => idx !== index
                  );

                  setFieldValue(fieldName, dateRangeValues);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};
